<!-- This div is for bulk purchase-Invalid user  infirmation  -->
<div class="d-flex flex-column align-items-center justify-content-center p-0 m-0 gap-0">
  <div *ngIf="invalidUsers.length">
    <p>Below are few of your guests have already purchased the tickets for this event, they will be excluded for the
      payment</p>
  </div>
  <div *ngIf="invalidUsers" class="d-flex col-12 justify-content-start gap-2 p-0 align-items-center fs-8">
    <ul class="d-flex gap-4">
      <li *ngFor="let userDetails of invalidUsers"> {{userDetails.name}}</li>
    </ul>
  </div>

  <div></div>
  <!-- This div is for subcription confirmation infirmation  -->
  <div *ngIf="modalData.purchaseTransactionType!=='subscribed'">
    <p style="color: white;"> {{modalData.purchaseTransactionType==='subscriptionError'?'Error Occured while fetching
      Subcription details!':'You will now be redirected to Cinejoy on Creatics Enterprises STRIPE secure payment. Please
      click “OK” to proceed.'}}</p>
  </div>
  <div *ngIf="modalData.purchaseTransactionType==='subscribed'">
    <p style="color: white;"> You have already Purchased <strong>{{subscriptions.allAccessPass?' All Access Pass':''}}
        {{subscriptions.spotlightAccessPass&&!subscriptions.allAccessPass?' Spotlight Access Pass ':''}}
        {{subscriptions.showcaseAccessPass&&!subscriptions.allAccessPass?' Showcase Access Pass ':''}}</strong> for
      Cinejoy.</p>
  </div>
  <div *ngIf="modalData.purchaseTransactionType==='subscribed'">
    <p style="color: white;"> For More details please check<a (click)="openMyTicket()" class="text-danger"
        style="text-decoration: none; cursor: pointer;"> My Tickets</a> </p>
  </div>

  <div class="align-self-start" *ngIf="invalidUsers.length">
    <p> Your final ticket amount is:{{((modalData.guestUsers+1) * modalData.ticketPrice) / 100
      +(modalData.emptyTicketCount * modalData.ticketPrice) / 100 | currency }}
    </p>
  </div>
  <div class="d-flex gap-2">
    <button mat-raised-button style="width: 6rem; height: 2.5rem; font-size: 1rem;" (click)="closeModal()"
      *ngIf="modalData.purchaseTransactionType!=='subscriptionError'">{{modalData.purchaseTransactionType==='subscribed'?'Got
      it':'Cancel'}}</button>
    <!-- This is button is for puchase confirmation -->
    <button mat-raised-button color
      style="background: #de1b36; width: 6rem; height: 2.5rem;color: white;font-size: 1rem" (click)="proceedPayment()"
      *ngIf="modalData.purchaseTransactionType!=='subscriptionError'&&modalData.purchaseTransactionType!=='subscribed'">OK</button>
    <!-- This Button is for subscription error handeling  -->
    <button *ngIf="modalData.purchaseTransactionType==='subscriptionError'" mat-raised-button color
      style="background: #de1b36; width: 6rem; height: 2.5rem;color: white;font-size: 1rem"
      (click)="logoutUser()">OK</button>

  </div>
</div>